export const REFERRAL_KEY = 'referral-source';
export const WINDFALL_REFERRAL_VALUE = 'windfall';
export const WINDFALL_LOCAL_STORAGE_KEY = 'windfall';
